import * as React from 'react';
import { LeftOutlined, RightOutlined, VerticalRightOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import withStyles from 'react-jss';
import { CssType, StylesProps, ThemeType } from 'src/theme/jss-types';
import { useTranslation } from 'react-i18next';

const styles = (theme: ThemeType): CssType => ({
  disabledStyle: {
    pointerEvents: 'none',
    cursor: 'default',
    color: '#CCCCCC !important',
  },
});
interface Props extends StylesProps<ReturnType<typeof styles>> {
  pageNumber: number;
  isNext: boolean;
  loading: boolean;
  onFirstClick: () => void;
  onPrevClick: () => void;
  onNextClick: () => void;
}
const SimplePaginator = (props: Props) => {
  const { pageNumber, isNext, classes, loading } = props;
  const { t } = useTranslation();

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        padding: '5px',
        cursor: 'pointer',
      }}
    >
      <Tooltip title={t("Go to First Page")}>
        {/* eslint-disable jsx-a11y/anchor-is-valid */}
        <a>
          <VerticalRightOutlined
            className={pageNumber !== 1 && !loading ? '' : classes.disabledStyle}
            style={{ marginRight: '5px' }}
            onClick={pageNumber !== 1 && !loading ? props.onFirstClick : undefined}
          />
        </a>
      </Tooltip>
      <Tooltip title={t("Go to Previous Page")}>
        <a>
          <LeftOutlined
            className={pageNumber !== 1 && !loading ? '' : classes.disabledStyle}
            onClick={pageNumber !== 1 && !loading ? props.onPrevClick : undefined}
          />
        </a>
      </Tooltip>
      <div style={{ margin: '0 5px', fontSize: 14 }}>{props.pageNumber}</div>
      <Tooltip title={t("Go to Next Page")}>
        <a>
          <RightOutlined
            className={isNext && !loading ? '' : classes.disabledStyle}
            onClick={isNext && !loading ? props.onNextClick : undefined}
          />
        </a>
      </Tooltip>
    </div>
  );
};

export default withStyles(styles, { injectTheme: true })(SimplePaginator);
